{
  "chapel": {
    "u0": -13,
    "chordU": 49,
    "vc": 21,
    "half": 5.7,
    "eaveY": 12,
    "ridgeY": 18.7,
    "apse": "polygonal"
  },
  "belfry": {
    "u": -4,
    "v": 21,
    "radius": 0.7,
    "foot": 18.2,
    "eaves": 21,
    "tip": 25
  },
  "ranges": [
    {
      "id": "west-bank-range",
      "u": -17,
      "v": -10,
      "angleDeg": 80,
      "length": 60,
      "width": 8,
      "eaves": 8.3,
      "ridge": 13,
      "floors": 2,
      "bays": 12,
      "roof": "tile",
      "passage": 3,
      "blindSides": [1]
    },
    {
      "id": "south-range",
      "u": 20.5,
      "v": -41,
      "angleDeg": 0,
      "length": 84,
      "width": 8,
      "eaves": 8.2,
      "ridge": 13,
      "floors": 2,
      "bays": 16,
      "roof": "slate",
      "passage": 0,
      "blindSides": [1, 3],
      "doorSide": 2
    },
    {
      "id": "east-angled-range",
      "u": 65,
      "v": -9,
      "angleDeg": 72,
      "length": 60,
      "width": 8,
      "eaves": 7.4,
      "ridge": 12.2,
      "floors": 2,
      "bays": 12,
      "roof": "tile",
      "passage": 0,
      "blindSides": [3],
      "doorSide": 2
    },
    {
      "id": "court-cross-range",
      "u": 25.5,
      "v": -6,
      "angleDeg": 90,
      "length": 40,
      "width": 7.5,
      "eaves": 9.3,
      "ridge": 13.5,
      "floors": 3,
      "bays": 8,
      "roof": "slate",
      "passage": 3,
      "roofGables": {
        "centres": [-12, 0, 12],
        "halfWidth": 1.1,
        "v0": 1.6,
        "v1": 3.75,
        "eaves": 12.1,
        "ridge": 13.4,
        "sill": 9.8,
        "top": 10.8
      }
    }
  ],
  "courts": [
    {
      "u0": -12.8,
      "u1": 21.6,
      "v0": -36.8,
      "v1": 15.1
    },
    {
      "u0": 29.4,
      "u1": 52,
      "v0": -33,
      "v1": 15.1
    }
  ],
  "gardens": [
    {
      "u0": -7,
      "u1": 16,
      "v0": -26,
      "v1": 8
    },
    {
      "u0": 34,
      "u1": 47,
      "v0": -25,
      "v1": 8
    }
  ],
  "walls": [
    {
      "from": [55.8, 21],
      "to": [58.5, 21],
      "width": 0.35,
      "height": 1.7
    },
    {
      "from": [62, 21],
      "to": [73.8, 25],
      "width": 0.35,
      "height": 1.7
    }
  ],
  "note": "The 1538 painting and 1544 woodcut guide the orchard-side polygonal chapel, roof belfry, unequal bank/south/east ranges, cross-range and two cultivated courts. The 1760 view is a later interpretation derived from the same map, not an additional medieval survey. All dimensions, elevations, floors, bays, gablets, bed shapes, passage positions and hidden elevations are fitted estimates. The northern orchard bank building remains unresolved rather than represented by an invented institutional hall. The orchard remains outside this core reservation, with its existing terrain-following trees; the Scafferij island and both Nonnen waterways remain separate. Later hospital buildings and modern internal streets are absent."
}
